/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:23:24
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 14:06:08
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import PaymentsList from '@/components/PaymentsAndInvoices/PaymentsList';
import InvoicesAndCorrectionList from '@/components/PaymentsAndInvoices/InvoicesAndCorrectionList';

// CONTAINER ///////////////////////////////////////////////////////////////////
const PaymentsAndInvoices = {
  components: { PaymentsList, InvoicesAndCorrectionList },
  store,
  computed: {
    ...mapGetters(['customerPayments', 'pendingStoreActions', 'customerInvoices', 'customerCorrectionInvoices', 'acl']),
  },
  template: `
    <div class="container-fluid animated fadeIn">
      <div class="row">
        <InvoicesAndCorrectionList 
          :customer-invoices="customerInvoices"
          :customer-correction-invoices="customerCorrectionInvoices"
          :is-loading="pendingStoreActions.includes('getCustomerPaymentsData') || pendingStoreActions.includes('getCustomerInvoicesData')"
          :acl="acl" />      
        <PaymentsList :customer-payments="customerPayments" :is-loading="pendingStoreActions.includes('getCustomerPaymentsData')" 
          :acl="acl" />
      </div>
    </div>
  `,
};

export default Vue
  .component('PaymentsAndInvoices', PaymentsAndInvoices);



// WEBPACK FOOTER //
// ./src/containers/PaymentsAndInvoices/index.js